import React from "react";
import {MERCHANT_NOTIFICATIONS} from "../../components/notificationScope";
import {CabinetSettings} from "../CabinetSettings";

/** «Настройки» мерчанта: вход в кабинет и уведомления. */
export function MerchantSettingsPage(): JSX.Element {
  return <CabinetSettings scope={MERCHANT_NOTIFICATIONS} className="merchant-page merchant-settings-page"/>;
}
